import React from 'react';
import './../faq.scss';
import FAQItem from './FAQItem';

const FAQ = () => {

  return (
    <>
      <div className='faq' role="region" aria-label="Frequently Asked Questions">
        {/* 7.5 heading-order fix: was <h1>, creating a second top-level heading sibling to
            the page's actual <h1> (Main.js hero). Demoted to <h2> so it nests correctly under
            the page's single <h1>, matching Trending Content/Testimonials/Growth Tracking; the
            "General"/"Service & Support" <h3> subheaders below already nest correctly under
            this heading level. */}
        <h2 className='faq-header'>
          Frequently Asked Questions
        </h2>
        <div className='faq-container'>
          <div className='faq-subheader'>
            <h3 className='subheader-title'>General</h3>
            <div>
              <FAQItem question="What is EE PASS?">
                <p>EE PASS gives educators 24/7 access to individualized training, certification tools, and real-time support designed to improve instruction and evaluation.</p>
                <p>Developed by NIET’s team of education professionals—with decades of on-the-ground experience supporting thousands of schools nationwide—EE PASS is your one-stop platform for professional learning and growth.</p>
                <p>As part of NIET’s comprehensive system of support for districts and schools, EE PASS extends professional learning, deepens instructional knowledge, and builds more consistent coaching across classrooms and schools.</p>
              </FAQItem>
              <FAQItem question="What is EE PASS Enhanced Search?">
                Enhanced Search allows educators and team leaders to quickly locate high-quality content within EE PASS Content Library. 
                It is a closed-source tool that produces results from resources within EE PASS Content Library only. By typing in a natural-language 
                question or topic, Enhanced Search provides relevant resources such as classroom lesson examples, instructional tools and rubrics, observation, feedback, or coaching strategies.
              </FAQItem>
            </div>
          </div>

          <div className='faq-subheader'>
            <h3 className='subheader-title'>Service & Support</h3>
            <div>
              {/* <FAQItem question="Can I access EE PASS from a mobile device?">
                Yes, you can access EE PASS from a mobile device using an updated web browser application.
              </FAQItem> */}
              <FAQItem question="Who do I contact for technical support?">
                Email <a href="mailto:support@niet.org?subject=EEPASS v2 Technical Support">support@niet.org</a>, call 1-800-575-NIET or click the Contact Us button at the bottom right corner of the EE PASS website.
              </FAQItem>
              <FAQItem question="How do I reset my password?">
                To reset your password, click the Forgot Password link and follow the prompts on screen to verify your email address and process a verification code. For assistance, contact support@niet.org.
              </FAQItem>
              <FAQItem question="What can I do to prepare my system to access EE PASS?">
                  <p>Google Chrome and Microsoft Edge are our most compatible web browsers, so use one of these if possible. (If you don’t have access to update your browser, please follow up with your system administrator.)</p>
                  <p>Ensure that you are connected to a wi-fi network that has good speed.</p>
                  <p>Pop-ups must be enabled on your web browser to view certain resources.</p>
                  <p>Be sure your browser's zoom is set to 100% or below. The recommended display resolution for your device is 1920 x 1080 with zoom set to 100% or below.</p>
              </FAQItem>
              {/* <FAQItem question="How do I update my profile?">
              Once you are logged into EE PASS you can update your profile picture and information by click on Your Name > Profile. When you access your profile you can change the following: user profile picture, name, email, phone number, password, configure multi-factor authentication settings and update your content preferences.
              </FAQItem> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQ;